import * as appConfigActions from './appconfig.actions';

export interface AppConfigState {
    appVersion: string
}

export const INIT_APPCONFIG_STATE: AppConfigState = {
    appVersion: '4.7.8.1'
};


export function reducer(state: AppConfigState = INIT_APPCONFIG_STATE, {type, payload}: appConfigActions.All): AppConfigState {

    switch (type) {
        case appConfigActions.SET_APP_VERSION: {
            return Object.assign({}, state, { appVersion: payload })
        }

        default: {      
            return state;
        }
    }
}

// SELECTORS
export const getAppVersion = (state: AppConfigState) => state.appVersion;



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/reducers/appconfig.reducer.ts